import React, { useState, useEffect } from "react";
import Tabs from "@/components/common/tab/Tab";
import { Building, CheckCircle, Users } from "lucide-react";
import styles from "./UserManagement.module.css";
import ManagementHeader from "../admin/managementHeader/ManagementHeader";
import AlertMessage from "@/components/layout/message/AlertMessage";
import StatsGrid from "../admin/statsCard/StatsCard";
import { useStats } from "./useStats";
import UserSection from "./components/userSection/UserSection";
import InstitutionSection from "./components/institutionSection/InstitutionSection";

const UserManagementPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState<"users" | "institutions">("users");
    const { stats, error: statsError, refresh } = useStats();

    useEffect(() => {
        document.body.classList.add("solid-public-bg");
        return () => document.body.classList.remove("solid-public-bg");
    }, []);

    const statsItems = [
        {
            icon: <Users />,
            label: "Total de usuarios",
            value: stats?.totalUsers ?? 0,
            iconColor: "#3b82f6",
        },
        {
            icon: <CheckCircle />,
            label: "Usuarios activos",
            value: stats?.activeUsers ?? 0,
            iconColor: "#10b981",
        },
        {
            icon: <Building />,
            label: "Total de instituciones",
            value: stats?.institutionCount ?? 0,
            iconColor: "#8b5cf6",
        },
    ];

    return (
        <div className={styles["container-main"]}>
            <ManagementHeader />

            <AlertMessage type="error" title="Error en estadísticas">
                {statsError?.generalMessage}
            </AlertMessage>
            <StatsGrid items={statsItems} />

            <Tabs
                items={[
                    { key: "users", label: "Gestionar usuarios" },
                    { key: "institutions", label: "Gestionar instituciones" },
                ]}
                activeKey={activeTab}
                onTabChange={(key) => setActiveTab(key as "users" | "institutions")}
            />

            {activeTab === "users" ? (
                <UserSection refreshStats={refresh} />
            ) : (
                <InstitutionSection refreshStats={refresh} />
            )}
        </div>
    );
};

export default UserManagementPage;
